import React from "react";
import { Button, Card, CardActions, IconButton, Stack } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

export default function ProfileSaveBar({ onReload }) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
        position: { xs: "static", md: "sticky" },
        bottom: 0,
        zIndex: 1,
      }}
    >
      <CardActions sx={{ justifyContent: "space-between", p: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton color="inherit" onClick={onReload} title="Neu laden">
            <RefreshRoundedIcon />
          </IconButton>
        </Stack>
        <Button
          type="submit"
          variant="contained"
          sx={{
            bgcolor: "orange",
            "&:hover": { bgcolor: "#cc7a00" },
            borderRadius: 2,
            px: 3,
            color: "#000",
          }}
        >
          Änderungen speichern
        </Button>
      </CardActions>
    </Card>
  );
}
